var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" wola carga "),_c('form',{attrs:{"enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}})]),_c('button',{on:{"click":function($event){return _vm.click()}}},[_vm._v("clickk ")])])}
var staticRenderFns = []

export { render, staticRenderFns }